import { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Table } from 'app/components/table/table';
import { ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { Button } from 'app/components/common/Button';
import { Icon } from 'app/components/common/Icon';
import Config from 'Config';
import { buildAspAgtListe, IAspAgt, IAspAgtListRow } from './asp.mock.data';

interface IAspAgtListe {
	selectedAgtId?: number;
	onSelectAgt: (agt: IAspAgt) => void;
}

// Mock der normalen Agenturliste (VBL-Sicht, vgl. AgenturList + VblAgenturListCols)
export const AspAgtListe = observer((props: IAspAgtListe) => {
	const tm = useMemo(() => {
		const tm = new TableModel<IAspAgtListRow, number>();
		const cols: ITableColumn<IAspAgtListRow, number>[] = [
			{
				label: 'Agentur',
				path: 'agt.name',
			},
			{
				label: 'GP',
				path: 'gp',
			},
			{
				label: 'VTNR',
				path: 'agt.agtId',
			},
			{
				label: 'Fokusthemen' + Config.currentPlanYear,
				path: 'fokusthemen.length',
				render: (row: TableRow<IAspAgtListRow>) => (
					<div className="tag-list whitespace-wrap">
						{row.data.fokusthemen.map((t) => (
							<span className="tag is-small" style={{ backgroundColor: t.background, color: t.color || 'inherit' }} key={t.short}>
								{t.short}
							</span>
						))}
					</div>
				),
			},
			{
				label: 'BP ' + Config.currentPlanYear,
				path: 'bpMine.count',
				render: (row: TableRow<IAspAgtListRow>) => (
					<>
						{row.data.bpMine.count} / {row.data.bpMine.total}
					</>
				),
			},
			{
				label: 'BP Spezi ' + Config.currentPlanYear,
				path: 'bpSpezi.count',
				render: (row: TableRow<IAspAgtListRow>) => (
					<>
						{row.data.bpSpezi.count} / {row.data.bpSpezi.total}
					</>
				),
			},
			{
				label: 'Schwerpunkt ' + Config.currentPlanYear,
				path: 'schwerpunkt.length',
				render: (row: TableRow<IAspAgtListRow>) => (
					<div className="agt-list-schwerpunkt">
						{row.data.schwerpunkt.map((r) => (
							<span className={`tag color-${r}`} key={r}>
								{r}
							</span>
						))}
					</div>
				),
			},
		];

		tm.setCols(cols);
		tm.sortBy = 'agt.name';
		tm.sortAsc = true;
		tm.idProperty = 'agt.agtId';
		tm.idType = 'number';
		return tm;
	}, []);

	tm.onRowClick = (row: TableRow<IAspAgtListRow>) => {
		props.onSelectAgt(row.data.agt);
	};

	useEffect(() => {
		tm.setRowData(buildAspAgtListe());
		tm.sort();
	}, [tm]);

	useEffect(() => {
		tm.setSelectedId(props.selectedAgtId);
	}, [tm, props.selectedAgtId]);

	return (
		<div className="agt-list-container">
			<div className="agentur-filter-container is-collapsed">
				<div className="agentur-filter-count">12 / 12&nbsp;Agenturen&nbsp;</div>
				<div className="current-filters"></div>
				<div className="toggle-filters">
					<Button className="button is-inverted">
						<Icon iconClass="filter" />
					</Button>
				</div>
			</div>
			<Table modifier="left-col-bold" tm={tm} stickyHeader={true} />
		</div>
	);
});
